var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-img"},[_c('div',{staticClass:"set-heights"},[_c('img',{attrs:{"src":require("@/assets/cover-01.jpg"),"alt":""}}),_c('TicketBooking')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }